import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';
import Text from './text';
import { theme } from 'styles/theme/theme';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  text: string | number;
  textSize?: 'small' | 'medium' | 'large';
  color?: string;
}

function ValueBlock(props: IProps) {
  const { text, textSize = 'medium', color = theme.colors.SurfaceWhite, ...rest } = props;

  return (
    <MainBlock className={'flex-center'} {...rest}>
      <Text color={color} size={textSize}>
        {text}
      </Text>
    </MainBlock>
  );
}

export default ValueBlock;

const MainBlock = styled.div<{ width?: string; height?: string }>`
  background: ${theme.colors.SurfaceRichBlack60};

  width: 30px;
  height: 20px;
`;
